import * as React from "react";
import { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Autocomplete,
  Paper,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addSEO } from "../../redux/Slices/extSlice";

export default function AddDetails({ setUpdate }) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [description, setDesc] = useState("");
  const [data, setData] = useState("");

  const pageList = [
    { label: "/" },
    { label: "/about-us" },
    { label: "/contact-us" },
    { label: "/privacy-policy" },
    { label: "/terms-conditions" },
  ];

  const notify = (v) =>
    toast.success(v, { position: "top-right", theme: "light" });

  const failure = (v) =>
    toast.error(v, { position: "top-right", theme: "light" });

  const handleSubmit = (e) => {
    e.preventDefault();
    const seodata = { title, desc: description, page: data };

    dispatch(addSEO(seodata))
      .then((response) => {
        setTitle("");
        setDesc("");
        setData("");
        if (response.payload.code === 200) notify(response.payload.message);
        else failure(response.payload.message);
      })
      .catch((error) => failure(error));

    setUpdate((prev) => !prev);
  };

  return (
   <Box sx={{ pl: { xs: 0, md: "17%" }, pt: "90px" }}>
      {/* Heading */}
      <Typography
        variant="h5"
        fontWeight={600}
        sx={{ mb: 3, pl: { xs: 2, md: 10 } }}
      >
        Add Data
      </Typography>

      {/* Form Container */}
      <Paper
        elevation={0}
        sx={{
          border: "1px solid #e5e5e5",
          borderRadius: "14px",
          p: { xs: 2, md: 4 },
          width: "90%",
          mx: "auto",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            {/* Seo Title */}
            <Grid item xs={12} md={4}>
              <Typography fontWeight={500} mb={1}>
                Seo Title
              </Typography>
              <TextField
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>

            {/* Seo Description */}
            <Grid item xs={12} md={4}>
              <Typography fontWeight={500} mb={1}>
                Seo Desc
              </Typography>
              <TextField
                fullWidth
                value={description}
                onChange={(e) => setDesc(e.target.value)}
              />
            </Grid>

            {/* Page Name */}
            <Grid item xs={12} md={4}>
              <Typography fontWeight={500} mb={1}>
                Page Name
              </Typography>
              <Autocomplete
                disablePortal
                options={pageList}
                value={pageList.find((x) => x.label === data) || null}
                onChange={(e, val) => setData(val ? val.label : "")}
                renderInput={(params) => (
                  <TextField {...params} label="Select Page" fullWidth />
                )}
              />
            </Grid>

            {/* Submit button */}
            <Grid item xs={12} textAlign="center">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  width: { xs: "100%", sm: "200px" },
                  background: "linear-gradient(90deg,#6A4FE0,#7B6CFF)",
                  py: 1.2,
                  fontSize: "16px",
                  borderRadius: "10px",
                  textTransform: "none",
                  "&:hover": {
                    background: "linear-gradient(90deg,#5a43c5,#6a59e8)",
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <ToastContainer />
    </Box>
  );
}
